import { render, staticRenderFns } from "./TrailEditor.vue?vue&type=template&id=38d28dad&scoped=true"
import script from "./TrailEditor.vue?vue&type=script&lang=js"
export * from "./TrailEditor.vue?vue&type=script&lang=js"
import style0 from "./TrailEditor.vue?vue&type=style&index=0&id=38d28dad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d28dad",
  null
  
)

export default component.exports